<template>
    <div class="subtype">
        <vuex-select
            class="subtype__select"
            :placeholder="toSentenceCase($t('planning.nominations.selectSubType'))"
            :options="options"
            item-value="key"
            return-object
            :getter="() => selectedValue"
            :setter="value => (selectedValue = value)"
        />
        <div>
            <span class="subtype__button  font-weight-bold" @click="$emit('cancel')">
                {{ toSentenceCase($t('actions.cancel')) }}
            </span>
            <v-btn
                text
                secondary
                class="subtype__button"
                :disabled="!selectedValue"
                @click="emitSet({ selectedValue })"
            >
                {{ toSentenceCase($tkey('set')) }}
            </v-btn>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    options: {
        type: Array,
        default: () => [],
    },
    initialValue: {
        type: Object,
        default: undefined,
    },
});
const emit = defineEmits(['cancel', 'setValue']);

let initialSelectedValueOptions = null;
if (props.initialValue && props.initialValue.key) {
    initialSelectedValueOptions = props.options.find(opt => opt.key === props.initialValue.key);
}
const selectedValue = ref(initialSelectedValueOptions || props.initialValue);

const emitSet = ({ selectedValue: value }) => {
    emit('setValue', value);
};
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins.scss';
@import '@style/base/_variables.scss';

.subtype {
    padding: 1rem;
    @include flex-row;
    flex-wrap: wrap;
    justify-content: flex-end;

    &__select {
        padding-bottom: 1rem;
        max-width: 13rem;
    }
    &__button {
        color: $promo-primary-colour;
        margin-left: 0.5rem;
        cursor: pointer;
    }
}
</style>
